<template>
  <section>
    <div class="br-pagetitle d-flex justify-content-between align-items-center">
      <div class="d-flex align-items-center" style="min-height: 70px">
        <i class="icon iconfont icon-ali1688"></i>
        <div class="mg-l-20">
          <h4>{{ $t("product.1688账号授权管理") }}</h4>
        </div>
      </div>
      <div class="tx-right">
        <a
          v-if="isSysRights('Account1688.getAliCode')"
          href="javascript:;"
          class="btn btn-success"
          @click="add1688Auth"
          >{{ $t("product.新增1688账号授权") }}</a
        >
      </div>
    </div>
    <div
      class="d-flex align-items-center justify-content-start pd-x-20 pd-sm-x-30"
    >
      <div class="clear-key">
        <a
          v-show="fName"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('name')"
        >
          {{ $t("product.自定义名称：") }}
          <span class="mg-r-10">{{ fName }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fResourceOwner"
          href="javascript:;"
          :name="$t('product.中文')"
          class="mg-r-15"
          @click="clearKey('resourceOwner')"
        >
          {{ $t("product.1688账号：") }}
          <span class="mg-r-10">{{ fResourceOwner }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fAuthStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('authStatus')"
        >
          {{ $t("product.授权状态：") }}
          <span class="mg-r-10">{{ $t(authStatusArr[fAuthStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
        <a
          v-show="fUseStatus"
          href="javascript:;"
          class="mg-r-15"
          @click="clearKey('status')"
        >
          {{ $t("product.启用状态：") }}
          <span class="mg-r-10">{{ $t(authUseStatusArr[fUseStatus]) }}</span>
          <i class="fa fa-close"></i>
        </a>
      </div>
      <div class="mg-l-auto"></div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["fName", "fResourceOwner", "fAuthStatus", "fUseStatus"],
  data() {
    return {
      authStatusArr: arrDict.auth1688Status,
      authUseStatusArr: arrDict.auth1688UseStatus,
    };
  },
  methods: {
    add1688Auth() {
      this.$emit("add1688Auth");
    },
    clearKey(type) {
      this.$emit("clearKey", type);
    },
  },
};
</script>